import React from "react";
import { Grid } from "@mui/material";
import ProjectUsersList from "../../components/project-team/ProjectUsersList";
import DashboardLayout from "../../layout/dashboard/DashboardLayout";

const ProjectTeam = () => {

  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <ProjectUsersList />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default ProjectTeam;
